export const valueData = [
  {
    id: 1,
    img: `/img/logo/no-image.png`,
    title: 'Title Value 1',
    description:
      'Eiusmod voluptate aliqua sunt incididunt aliqua ut non ea ut cupidatat minim dolore dolor. Aliquip tempor adipisicing aliquip mollit commodo. Duis veniam dolore deserunt velit nulla dolor aliquip qui deserunt nisi occaecat sit ad. Non officia ea occaecat ex.',
  },
  {
    id: 2,
    img: `/img/logo/no-image.png`,
    title: 'Title Value 2',
    description:
      'Eiusmod voluptate aliqua sunt incididunt aliqua ut non ea ut cupidatat minim dolore dolor. Aliquip tempor adipisicing aliquip mollit commodo. Duis veniam dolore deserunt velit nulla dolor aliquip qui deserunt nisi occaecat sit ad. Non officia ea occaecat ex.',
  },
];
